import { render, staticRenderFns } from "./SlideTab.vue?vue&type=template&id=2ff09628&"
import script from "./SlideTab.vue?vue&type=script&lang=js&"
export * from "./SlideTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports